<script>
export default {
  name: 'HubVideoUploader',
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSuccessUploading(files) {
      this.$emit('input', files[0].cdnUrl)
      this.$emit('file-loaded')
    },
    onDeletedFile() {
      this.$emit('input', '')
      this.$emit('deleted-file')
    },
  },
}
</script>

<template>
  <file-uploader
    :image="value"
    input-accept-types="mp4"
    :class="$style.uploader"
    :default-tabs="'file'"
    :can-delete="true"
    :disabled="disabled"
    @input="onSuccessUploading"
    @deleted-file="onDeletedFile"
  >
    <template #button-text>
      <div
        :class="$style.uploadPlus"
      >
        +
      </div> Select file
    </template>
  </file-uploader>
</template>

<style lang="scss" module>
.uploader {
  width: 100%;
}

.uploadPlus {
  display: inline-flex;
  margin-right: rem(4px);
  transform: scale(1.6);
}
</style>
